import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// AuthCallback consumes session_id from URL fragment after Google OAuth redirect.
// Effects in StrictMode fire twice — use useRef to make this idempotent.
export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    exchangeGoogleSession(sessionId)
      .then(() => {
        window.history.replaceState({}, "", "/account");
        navigate("/account", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [exchangeGoogleSession, location.hash, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-[#ffffff] text-[#000000]/70"
    >
      <p className="overline animate-pulse">Signing you in…</p>
    </div>
  );
}
